import { getLocale, t } from "../../../features/store-language/i18n.ts";
import AppFeedback from "../../shared/AppFeedback.tsx";

export function showAgencyAccountLockout(error: unknown): boolean {
  const response = (error as { response?: { data?: unknown } } | null)?.response;
  if (!response?.data || typeof response.data !== "object") return false;

  const details = response.data as Record<string, unknown>;
  if (details.code !== "agency-account-locked" || typeof details.lockedUntil !== "string") return false;

  const lockedUntil = new Date(details.lockedUntil);
  if (!Number.isFinite(lockedUntil.getTime())) return false;

  const formattedTime = new Intl.DateTimeFormat(getLocale(), {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    timeZoneName: "short",
  }).format(lockedUntil);

  void AppFeedback.error({
    title: t("حساب موقتاً قفل شده است"),
    description: t("حساب شما تا {{until}} (به وقت دستگاه شما) قفل است؛ پس از آن دوباره تلاش کنید.", {
      until: formattedTime,
    }),
  });
  return true;
}
